/**
 * The heading a public collection page (or a title content block) shows: a sub-page's own name
 * when the viewer is inside one, otherwise the collection link's name. Both names are non-empty
 * in production (Save gates on a collection name; the sub-page rename input refuses empty).
 */
export const getPublicShowcasePageTitle = ({
  collectionName,
  currentSubPageName,
}: {
  collectionName: string;
  currentSubPageName: string | undefined;
}) => currentSubPageName ?? collectionName;
